export const ProductInfoKey = {
  PRODUCT_NAME: 'productId',
  VOLUME: 'volume',
  PRODUCT_TYPE: 'productType',
  FACILITIES: 'facilities',
  RAW_MATERIAL_DATA: 'rawMaterialsData',
  COST_TF: 'costtoproduction',
  SELLING_TF: 'sellingprice',
  UNIT_PRODUCED_TF: 'unitsproduced',
  SINGLE_FACILITY: 'facilityId',
  RAW_MATERIAL_ID: 'rawMaterialId',
  WEIGHT: 'weight',
  processType: 'processType'
};
export const ProductInfoLabel = {
  PRODUCT_NAME: 'Product Name',
  VOLUME: 'Weight of each unit',
  PRODUCT_TYPE: 'Product Type',
  FACILITIES: 'Facilities',
  RAW_MATERIAL_DATA: 'Raw Materials',
  COST_TF: 'Cost to production',
  SELLING_TF: 'Selling price',
  UNIT_PRODUCED_TF: 'Unit Produced',
  SINGLE_FACILITY: 'Facility',
  RAW_MATERIAL_ID: 'Raw Material',
  WEIGHT: 'Weight',
  processType: 'Process Type'
};
